function pointsToPathData(points, width, height) {
    if (points.length === 0)
        return '';
    const [first, ...rest] = points;
    let d = `M ${first.x * width} ${first.y * height}`;
    for (const p of rest) {
        d += ` L ${p.x * width} ${p.y * height}`;
    }
    return d;
}
function getShapeCenter(shape, width, height) {
    switch (shape.type) {
        case 'box':
            return {
                cx: (shape.x + shape.width / 2) * width,
                cy: (shape.y + shape.height / 2) * height,
            };
        case 'circle':
            return {
                cx: shape.cx * width,
                cy: shape.cy * height,
            };
        case 'line':
        case 'arrow':
            return {
                cx: ((shape.x1 + shape.x2) / 2) * width,
                cy: ((shape.y1 + shape.y2) / 2) * height,
            };
        case 'freeform': {
            if (shape.points.length === 0)
                return { cx: 0, cy: 0 };
            let minX = shape.points[0].x, maxX = shape.points[0].x;
            let minY = shape.points[0].y, maxY = shape.points[0].y;
            for (const p of shape.points) {
                if (p.x < minX)
                    minX = p.x;
                if (p.x > maxX)
                    maxX = p.x;
                if (p.y < minY)
                    minY = p.y;
                if (p.y > maxY)
                    maxY = p.y;
            }
            return {
                cx: ((minX + maxX) / 2) * width,
                cy: ((minY + maxY) / 2) * height,
            };
        }
        case 'text':
            return {
                cx: (shape.x + shape.width / 2) * width,
                cy: (shape.y + shape.height / 2) * height,
            };
    }
}
function shapeToSvgElements(shape, width, height) {
    const strokeWidth = 2;
    let content;
    switch (shape.type) {
        case 'box':
            content = `<rect x="${shape.x * width}" y="${shape.y * height}" width="${shape.width * width}" height="${shape.height * height}" fill="none" stroke="${shape.color}" stroke-width="${strokeWidth}"/>`;
            break;
        case 'circle':
            content = `<ellipse cx="${shape.cx * width}" cy="${shape.cy * height}" rx="${shape.rx * width}" ry="${shape.ry * height}" fill="none" stroke="${shape.color}" stroke-width="${strokeWidth}"/>`;
            break;
        case 'line':
            content = `<line x1="${shape.x1 * width}" y1="${shape.y1 * height}" x2="${shape.x2 * width}" y2="${shape.y2 * height}" stroke="${shape.color}" stroke-width="${strokeWidth}"/>`;
            break;
        case 'arrow': {
            const markerId = `arrowhead-${shape.id}`;
            content = [
                `<defs>`,
                `  <marker id="${markerId}" markerWidth="10" markerHeight="7" refX="10" refY="3.5" orient="auto" markerUnits="strokeWidth">`,
                `    <polygon points="0 0, 10 3.5, 0 7" fill="${shape.color}"/>`,
                `  </marker>`,
                `</defs>`,
                `<line x1="${shape.x1 * width}" y1="${shape.y1 * height}" x2="${shape.x2 * width}" y2="${shape.y2 * height}" stroke="${shape.color}" stroke-width="${strokeWidth}" marker-end="url(#${markerId})"/>`,
            ].join('\n');
            break;
        }
        case 'freeform': {
            const d = pointsToPathData(shape.points, width, height);
            content = `<path d="${d}" fill="none" stroke="${shape.color}" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round"/>`;
            break;
        }
        case 'text': {
            const x = shape.x * width;
            const y = shape.y * height;
            const fontSize = shape.fontSize;
            // Escape text for XML
            const escaped = shape.text
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            content = `<text x="${x}" y="${y + fontSize}" font-size="${fontSize}" fill="${shape.color}" font-family="sans-serif">${escaped}</text>`;
            break;
        }
        default:
            return '';
    }
    // Wrap in rotation transform if shape has rotation
    if (shape.rotation) {
        const center = getShapeCenter(shape, width, height);
        return `<g transform="rotate(${shape.rotation}, ${center.cx}, ${center.cy})">\n${content}\n</g>`;
    }
    return content;
}
/**
 * Exports shapes as a standalone SVG string.
 * Denormalizes coordinates from 0-1 to pixel values.
 */
export function exportSvg(shapes, width, height) {
    const elements = shapes.map((shape) => shapeToSvgElements(shape, width, height)).join('\n');
    return [
        `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">`,
        elements,
        `</svg>`,
    ].join('\n');
}
